import { styled } from 'styled-components'
import COLORS from '@ui-components/colors'
import Text from '@web-ui-kit/text'
import Button from '@ui-components/button'

export const Container = styled.article`
  background-color: ${({ $isRebranding }) =>
    $isRebranding ? 'transparent' : COLORS.SECONDARY_50};
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
`

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  & > svg {
    width: 1rem;
  }
`
export const Title = styled(Text)`
  color: ${COLORS.SECONDARY_600};
`
export const Description = styled(Text)`
  color: ${COLORS.NEUTRAL_500};
`

export const Link = styled(Button)`
  && {
    color: ${COLORS.INFO_800};
    width: fit-content;
    &:hover {
      color: ${COLORS.INFO_400};
    }
  }
`
